import i18n from 'i18next';
import dayjs from 'dayjs';

export const formatDate = (date: string | null | undefined, full?: boolean) => {
	if (!date) return '';
	const locale = i18n.language;
	const options: Intl.DateTimeFormatOptions = {
		day: 'numeric',
		month: 'long',
		year: full ? 'numeric' : undefined,
	};
	return new Intl.DateTimeFormat(locale, options).format(new Date(date));
};

export const daysToNextBirthDay = (date: string) => {
	const birthday = dayjs(date);
	const today = dayjs();
	const nextBirthday = birthday.set('year', today.year());
	const isPast = nextBirthday.isAfter(today);

	const correctNextBirthday = isPast
		? nextBirthday
		: nextBirthday.add(1, 'year');

	return correctNextBirthday.diff(today, 'day') + 1;
};

export const getFutureAge = (date: string) => {
	const birthday = dayjs(date);
	return dayjs().diff(birthday, 'year') + 1;
};
